export default {"src":"/_next/static/media/yt.05885a49.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};